var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaambar36X36(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F5A458"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0981 8.12934C17.6935 8.01027 18.3065 8.01027 18.9019 8.12934C20.2248 8.39392 21.3648 9.22606 22.02 10.4054L28.2059 21.54C28.5627 22.1824 28.75 22.9051 28.75 23.6399C28.75 26.0279 26.8141 27.9638 24.4261 27.9638H11.5739C9.18588 27.9638 7.25 26.0279 7.25 23.6399C7.25 22.9051 7.43727 22.1824 7.79413 21.54L13.98 10.4054C14.6352 9.22606 15.7752 8.39392 17.0981 8.12934ZM18.6077 9.60021C18.2065 9.51998 17.7935 9.51998 17.3923 9.60021C16.5009 9.77849 15.7328 10.3392 15.2913 11.1339L9.10537 22.2685C8.8723 22.688 8.75 23.16 8.75 23.6399C8.75 25.1995 10.0143 26.4638 11.5739 26.4638H24.4261C25.9857 26.4638 27.25 25.1995 27.25 23.6399C27.25 23.16 27.1277 22.688 26.8946 22.2685L20.7087 11.1339C20.2672 10.3392 19.4991 9.77849 18.6077 9.60021Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.4638C17.5858 19.4638 17.25 19.128 17.25 18.7138V14.7138C17.25 14.2996 17.5858 13.9638 18 13.9638C18.4142 13.9638 18.75 14.2996 18.75 14.7138V18.7138C18.75 19.128 18.4142 19.4638 18 19.4638Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22.9638C18.4142 22.9638 18.75 22.628 18.75 22.2138V21.7138C18.75 21.2996 18.4142 20.9638 18 20.9638C17.5858 20.9638 17.25 21.2996 17.25 21.7138V22.2138C17.25 22.628 17.5858 22.9638 18 22.9638Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaambar36X36);
export default __webpack_public_path__ + "static/media/ALERTA AMBAR_36X36.e51b1d7b5707bca938b0705ca13ef7e6.svg";
export { ForwardRef as ReactComponent };